import { render, staticRenderFns } from "./widget-primary.vue?vue&type=template&id=18854562&scoped=true"
import script from "./widget-primary.vue?vue&type=script&lang=ts"
export * from "./widget-primary.vue?vue&type=script&lang=ts"
import style0 from "./widget-primary.vue?vue&type=style&index=0&id=18854562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18854562",
  null
  
)

export default component.exports